import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { trackBookingClick } from '../lib/analytics';

export default function BlogCTA({ city, slug, bookingUrl }) {
  const destination = bookingUrl || `/cities/${String(city || '').toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
  return (
    <section className="my-10 rounded-[2rem] border border-[#3f2e1e] bg-gradient-to-br from-[#26170f] to-[#111] p-7 sm:p-9">
      <div className="badge-cozy mb-4">Meet a local Ghostie</div>
      <h2 className="font-heading text-3xl sm:text-4xl mb-4">
        Ready to meet the stranger side of {city}?
      </h2>
      <p className="text-[#c7c7c7] leading-relaxed mb-3">
        Spend time with a local Ghostie who shares your curiosity for folklore, haunted-looking places, witchy details, dark history, quirky cafés and atmospheric streets.
      </p>
      <p className="text-[#a3a3a3] leading-relaxed mb-6">
        It is a personal Ghostie experience shaped around hidden stories, local conversation and the city’s more mysterious side.
      </p>
      <Link
        to={destination}
        className="btn-primary"
        onClick={() => trackBookingClick({ city, page_slug: slug, destination_url: destination })}
      >
        <Sparkles size={16} /> Meet a Ghostie in {city}
      </Link>
    </section>
  );
}
